export const OperationReturnType = Object.freeze({
  LIST: 'list',
  SINGLE: 'single',
})
